<template>
  <div>
    <div class="pay_dialog">
      <el-dialog :modal-append-to-body="false" :close-on-click-modal="false"
                 :title="title == 0 ? '加入购物车' : '修改授权信息'" :visible.sync="addShopCar"
                 width="910px"
                 :before-close="handlePayClose">
        <el-divider></el-divider>
        <div class="buy_info">
          <div class="buy_left">
            <div class="buy_left_title" v-if="goodsInfo.type != 2">
              <img :src="goodsInfo.url" alt="">
              <div>
                <p>{{ goodsInfo.song_name }}</p>
                <span>{{ goodsInfo.singer }}</span>
              </div>
            </div>
            <div class="buy_left_title" v-if="goodsInfo.type == 2">
              <img :src="goodsInfo.cover_url" alt="">
              <div>
                <p>{{ goodsInfo.title }}</p>
                <span>{{ goodsInfo.introduce }}</span>
              </div>
            </div>
            <div class="choose_box">
              <div v-for="(item, index) in specList" :key="index" class="choose">
                <div class='title1'>{{ item.title }}</div>

                <div class='spec'>
                  <!--                                  :class="[selectSpec[item.title] === its.name ? 'active' : '', its.able || index == 0 ? '' : 'disabled']">-->
                  <div class='spec-item' v-for="(its, ins) in item.list" :key="its.name1 + ins"
                       :class="[selectSpec[item.title] === its.name ? 'active' : '', its.able || index == 0 ? '' : 'disabled']">
                    <el-tooltip class="item" :open-delay="500" effect="dark" placement="top"
                                v-if="its.attr_des">
                      <div slot="content" class="item_content">
                        {{ its.attr_des }}
                      </div>
                      <span @click="changeSpec(item.title, its.name, index, item, its)">{{
                          its.name1
                        }}</span>
                    </el-tooltip>
                    <span v-else @click="changeSpec(item.title, its.name, index, item, its)">{{
                        its.name1
                      }}</span>

                  </div>
                </div>
              </div>
            </div>
            <div slot="footer" class="dialog-footer car_footer">
              <p v-if="price != 0">音乐价格 <span>￥{{ price }}</span> </p>
              <p v-else class="custom" @click="consult">点击此处，获取二维码询价</p>
              <div v-if="title != 1">
                <el-button class="inquiry newinquiry"  plain @click="consult" v-if="price != 0">咨询客服授权信息</el-button>
                <el-button class="inquiry newinquiry"    @click="consult" v-else>咨询客服授权信息
                </el-button>
                <el-button type="primary" @click="addCar" v-if="price != 0 && att_status === 2 ">加入购物车</el-button>
              </div>
              <div v-else-if="title == 1">
                <el-button type="primary" :disabled="price == 0" @click="changeInfo">修改信息</el-button>
              </div>
            </div>
          </div>
            <!-- 用户未认证 -->
            <div v-if="att_status === 0" class="buy_right newBuy_Right">
                <div class="noApprove sflex">
                    <img src="../../assets/home/unauthorized.png" alt="">
                </div>
                <p class="buyNow">购买前, 您需要先完成用户认证</p>
                <span>
                            实名认证信息将作为后续采购音乐版权的授权主体，以及开具发票的发票抬头
                        </span>
                <el-button class="inquiry" type="primary" @click="certification(0)">去认证</el-button>

            </div>
            <!-- 审核中 -->
            <div  v-else-if="att_status == 1" class="buy_right newBuy_Right" >
                <div class="noApprove sflex">
                    <img src="../../assets/home/audit.png" alt="">
                </div>
                <p class="buyNow">认证审核中</p>
                <span class="receive">
                            您好，根据您提交的认证信息。我们将在1个工作日内完成对您资料的审核，如有问题请通过扫码联系客服。
                        </span>
                <span class="tips">您可以将喜欢的歌曲先加入收藏。在审核通过(短信通知到您)后, 前往“个人中心”进行查看、购买。</span>
                <el-button class="inquiry" type="primary" @click="certification(1)">我知道啦</el-button>

            </div>
            <!-- 用户未通过 -->
            <div class="buy_right newBuy_Right"  v-else-if="att_status == 3" >
                <div class="noApprove sflex">
                    <img src="../../assets/home/Fail.png" alt="">
                </div>
                <p class="buyNow">身份认证未通过！</p>
                <span style="text-align: center;" v-if="explain" >
                            原因：{{explain}}
                        </span>
                <el-button class="inquiry" type="primary" @click="certification(3)">修改信息再提交认证</el-button>

            </div>
        </div>
      </el-dialog>
    </div>
    <div class="addCarSuccess">
      <el-dialog :modal-append-to-body="false" :close-on-click-modal="false" custom-class="delCarMusic"
                 :visible.sync="addCarSuccess" width="690px" :before-close="handleClose">
        <div class="payCarSuccess_title">
          <img src="../../assets/home/success.png" alt="">
          <p>已加入购物车</p>
        </div>
        <div class="payCarSuccess_info" v-if="goodsInfo.type == 1">
          <img :src="goodsInfo.url" alt="">
          <div>
            <p :title="goodsInfo.song_name + '-' + goodsInfo.singer">
              {{ goodsInfo.song_name }}-{{ goodsInfo.singer }}</p>
            <p class="hidden" :title="sceneName">授权信息：{{ sceneName }}</p>
            <span>￥{{ price }}</span>
          </div>
        </div>
        <div class="payCarSuccess_info" v-else-if="goodsInfo.type == 2">
          <img :src="goodsInfo.cover_url" alt="">
          <div>
            <p :title="goodsInfo.title">
              {{ goodsInfo.title }}</p>
            <p class="hidden" :title="sceneName">授权信息：{{ sceneName }}</p>
            <span>￥{{ price }}</span>
          </div>
        </div>
        <!-- 这里是加入购物车 -->
        <span slot="footer">
                    <el-button @click="chooseMusic">继续挑选音乐</el-button>
                    <el-button type="primary" @click="goShopCar">去购物车结算</el-button>
                </span>

      </el-dialog>
    </div>
    <transferVue ref="transfer"></transferVue>
    <codeVue ref="code"></codeVue>

  </div>
</template>

<script>
import transferVue from './transfer.vue'
import codeVue from '../dialog/code.vue'
import formateNum from '@/assets/js/money'


export default {
  data() {
    return {
        explain:'',
        att_status:'',
      addShopCar: false,
      isActive: 0,
      payList: [
        {
          title: '授权场景:',
          isActive: '',
          listInfo: []
        },
        {
          title: '授权权益:',
          isActive: '',
          listInfo: []
        },
        {
          title: '类型:',
          isActive: '',
          listInfo: []
        },
        {
          title: '投放渠道:',
          isActive: '',
          listInfo: []
        }, {
          title: '授权时间:',
          isActive: '',
          listInfo: []
        },
        {
          title: '授权范围:',
          isActive: '',
          listInfo: []
        }
      ],
      addCarSuccess: false,
      price: '暂无报价',
      cartId: '',
      sceneName: '',
      specList: [],
      skuList: [],
      selectSpec: {},  // 选择数据的对象 将已选的数据放在这个对象里面记录下来  用对象的好处在下面深拷贝处就能体验到了
      price_id: '',
      scene_id: '',//存下场景id，点击去购物车结算的时候用
      arr: [],
      skuArr:{},
      check: '',
      skuMatrix: {},
      auth_info_ids: [],
    }
  },
  components: {
    transferVue,
    codeVue
  },
  props: {
    carPeices: {
      type: Array,
      default: () => []
    },
    goodsInfo: Object,
    bothPrices: {
      type: Object,
      default: () => { }
    },
    title: {
      type: String,
      default: '0'
    },
    priceId: {
      type: Number,
    }
  },
  watch: {
    // 获取歌曲拥有的价格配置
    carPeices(val) {
      this.payList = [
        {
          title: '授权场景:',
          isActive: '',
          list: []
        },
        {
          title: '授权权益:',
          isActive: '',
          list: []
        },
        {
          title: '类型:',
          isActive: '',
          list: []
        },
        {
          title: '投放渠道:',
          isActive: '',
          list: []
        }, {
          title: '授权时间:',
          isActive: '',
          list: []
        },
        {
          title: '授权范围:',
          isActive: '',
          list: []
        },
      ]

      this.imgUrl = ''
      // this.logo = this.payChoose.url
      this.price = '暂无报价'
      let arr1 = []
      let arr2 = []
      let arr3 = []
      let arr4 = []
      let arr5 = []
      let arr6 = []
      val.map(i => {
        this.bothPrices.auth_scope.map(j => {
          if (i.auth_scope_id == j.id) {
            arr1.push(j)
          }
        })
        this.bothPrices.auth_time.map(j => {
          if (i.auth_time_id == j.id) {
            arr2.push(j)
          }
        })
        this.bothPrices.channel.map(j => {
          if (i.channel_id == j.id) {
            arr3.push(j)
          }
        })
        this.bothPrices.scene.map(j => {
          if (i.scene_id == j.id) {
            if (this.$store.state.cateId == j.id) {
              arr4.unshift(j)
            } else {
              arr4.push(j)
            }
          }
        })
        this.bothPrices.auth_type.map(j => {
          if (i.auth_type == j.id) {
            arr5.push(j)
          }
        })
        this.bothPrices.auth_info.map(j => {
          if (i.auth_info_id == j.id) {
            arr6.push(j)
          }
        })
      })
      arr1 = [...new Set(arr1)]
      arr2 = [...new Set(arr2)]
      arr3 = [...new Set(arr3)]
      arr4 = [...new Set(arr4)]
      arr5 = [...new Set(arr5)]
      arr6 = [...new Set(arr6)]
      this.payList[0].list = arr4
      this.payList[1].list = arr6
      this.payList[2].list = arr5
      this.payList[3].list = arr3
      this.payList[4].list = arr2
      this.payList[5].list = arr1
      let arr = [], tmp = []
      val.map((i, idx) => {
        tmp.push(i.scene_id, i.auth_info_id, i.auth_type, i.channel_id, i.auth_time_id, i.auth_scope_id)
        arr.push({
          // id: idx,
          specs: [i.scene_id, i.auth_info_id, i.auth_type, i.channel_id, i.auth_time_id, i.auth_scope_id],
          price: i.price
        })
      })
      // 处理数据
      this.specList = this.payList
      this.skuList = arr;
      // console.log(this.skuList)
      tmp = [...new Set(tmp)]
      //初始化sku矩阵列表
      tmp.map(v => {
          let a = []
          arr.map(item => {
              if (item.specs.indexOf(v) >= 0) {
                  a.push(...item.specs)
              }
          })
          this.skuMatrix[v] = [... new Set(a)]
      })

      // 初始化选择数据的对象
      this.specList.forEach(item => {
        this.$set(this.selectSpec, item.title, "");
      })
      // 将规格数据处理成我们视图所需要的数据类型
      this.specList = this.specList.map(item => {
        return {
          title: item.title,
          list: item.list.map(its => {
            return {
              name1: its.name + (its.description ?`（${its.description}）` : ''),
              name: its.id,
              // 判断是否可以选择
              able: true, // 注释的调试看逻辑代码 false  this.isAble(item.title, its.id)
              attr_des: its.attr_des,
            }
          })
        }
      })
      // 有价格id说明是购物车点击的
      if (this.priceId) {
        this.carPeices.map(i => {
          if (i.id == this.priceId) {
            this.selectSpec = {
              '授权场景:': i.scene_id,
              '授权权益:': i.auth_info_id,
              '类型:': i.auth_type,
              '投放渠道:': i.channel_id,
              '授权时间:': i.auth_time_id,
              '授权范围:': i.auth_scope_id,
            }
            this.scene_id = i.scene_id
          }
        })

      let skuArr = this.intersect(this.skuMatrix[this.selectSpec['授权场景:']],this.skuMatrix[this.selectSpec['授权权益:']])
      let auth_info_ids = this.getSceneInfoIds(this.scene_id)
      skuArr.push(...auth_info_ids)
      skuArr = [...new Set(skuArr)]

      this.specList.forEach(item => {
          item.list.forEach((its, idx) => {
              its.able = skuArr.indexOf(its.name) >= 0;
          })
      });
        // console.log(JSON.stringify(this.specList))
      } else {
        this.carPeices.some(i => {
          if (i.scene_id == this.$store.state.cateId) {
            // 价格配置默认是当前场景下面的第一个i
            this.selectSpec = {
              '授权场景:': i.scene_id,
              '授权权益:': i.auth_info_id,
              '类型:': i.auth_type,
              '投放渠道:': i.channel_id,
              '授权时间:': i.auth_time_id,
              '授权范围:': i.auth_scope_id,
            }
            this.scene_id = this.carPeices[0].scene_id

            // let ii = 0, temp = []
            // for (let key in this.selectSpec) {
            //   let ids = []
            //   temp.push(this.selectSpec[key])
            //   ids.push(...this.isAble(ii, this.selectSpec[key], ii >= 1 ? temp[ii-1] : 0, i.scene_id))
            //   this.arr[key] = ids
            //   this.arr.push(...new Set(ids))
            //   ii++
            // }

            let skuArr = this.intersect(this.skuMatrix[i.scene_id],this.skuMatrix[i.auth_info_id])
            let auth_info_ids = this.getSceneInfoIds(i.scene_id)
            skuArr.push(...auth_info_ids)
            skuArr = [...new Set(skuArr)]

            this.specList.forEach(item => {
              item.list.forEach((its, idx) => {
                  its.able = skuArr.indexOf(its.name) >= 0
              })
            });

            // console.log(this.specList)

            return true
          } else {
            // // 默认是价格配置的第一种
            this.selectSpec = {
                '授权场景:': this.carPeices[0].scene_id,
                '授权权益:': this.carPeices[0].auth_info_id,
                '类型:': this.carPeices[0].auth_type,
                '投放渠道:': this.carPeices[0].channel_id,
                '授权时间:': this.carPeices[0].auth_time_id,
                '授权范围:': this.carPeices[0].auth_scope_id,
            }
            this.scene_id = this.carPeices[0].scene_id
              let skuArr = this.intersect(this.skuMatrix[this.scene_id],this.skuMatrix[this.carPeices[0].auth_info_id])
              let auth_info_ids = this.getSceneInfoIds(this.scene_id)
              skuArr.push(...auth_info_ids)
              skuArr = [...new Set(skuArr)]

              this.specList.forEach(item => {
                  item.list.forEach((its, idx) => {
                      its.able = skuArr.indexOf(its.name) >= 0
                  })
              });
          }
        })
      }

    },
    selectSpec: {
      deep: true,
      handler(val) {
      // console.log("价格",val)
        let str = ''
        for (let i in val) {
          if (val[i] != '') {
            str += val[i]
          }
        }
        this.carPeices.some(i => {
          let str2 = i.scene_id + "" + i.auth_info_id + i.auth_type + i.channel_id + i.auth_time_id + i.auth_scope_id
          if (str == str2) {
            this.scene_id = i.scene_id
            let sceneName = '' //授权信息
            this.payList.map(d => {
              d.list.map(j => {
                if (i.scene_id == j.id) {
                  sceneName += j.name + '、'
                }
                if (i.auth_info_id == j.id) {
                  sceneName += j.name
                }
                if (i.auth_type == j.id) {
                  sceneName += j.name
                }
                if (i.channel_id == j.id) {
                  sceneName += j.name + '、'
                }
                if (i.auth_time_id == j.id) {
                  sceneName += j.name + '、'
                }
                if (i.auth_scope_id == j.id) {
                  sceneName += j.name
                }
              })
            })
            this.sceneName = sceneName
            this.price = formateNum(i.price * 1)
              // console.log('匹配：', i)
            this.price_id = i.id
            return true
          } else {
            this.price = '暂无报价'
            this.price_id = ''
            this.sceneName = ''
          }
        })
      }
    },
      addShopCar(val){
        if(val){
            this.$home.getAttestat().then(r =>{
                if(r.code == 200){
                    this.att_status =  r.data.att_status;
                    this.explain = r.data.explain;
                }

            })
        }
      }
  },
  mounted() {
    // this.getCarList()
  },
  methods: {
      certification(val) {
          switch (val) {
              case 0:
                  this.$router.push({
                      path: '/authentication'
                  })
                  break;
              case 3:
                  this.$router.push({
                      path: '/authentication',
                      query: {
                          flag: 'revise'
                      }
                  })
                  break;
          }
          this.addShopCar = false
      },
    consult() {
      this.$refs.code.paySuccess = true
    },
    // 判断规格是否可以被选择  核心函数 key当前的规格的title   value规格值
    isAble(key, value, prev_v, scene_id) {
      let check = []
      this.skuList.map(function (item) {
        if (item.specs[0] == scene_id) {
          if (item.specs[key] == value) {
            check.push(item.specs[key])
          } else if (item.specs[key-1] == prev_v) {
            check.push(item.specs[key])
          }
        }
      })
      return check
    },
    intersect(nums1, nums2) {
      nums1.sort((a,b) => a-b)
      nums2.sort((a,b) => a-b)
      let res = []
      let key1 = 0, key2 = 0, index = 0
      while(key1 < nums1.length && key2 < nums2.length){
          if(nums1[key1] < nums2[key2]) key1++
          else if(nums1[key1] > nums2[key2]) key2++
          else{
              res[index++] = nums1[key1]
              key1++
              key2++
          }
      }
      return res
    },
    getSceneInfoIds(scene_id) {
        let rs = []
        this.skuList.map(function (item) {
            if (item.specs[0] == scene_id) {
                rs.push(item.specs[1])
            }
        })
        return rs
    },
    // 点击事件
    changeSpec(key, value, index, item, its) {
      if (index == 0) {
        this.scene_id = value
      }
      if (this.selectSpec[item.title] === its.name) return
      if (this.selectSpec[key] === value) {
        this.selectSpec[key] = ''
      } else {
        this.selectSpec[key] = value
      }
      this.carPeices.some(i => {
        let x = i
        // delete x.id
        for (let j in x) {
            if (index == 0) {
                if (i[j] == its.name && i.scene_id == this.scene_id && j != 'id') {
                    // 点场景的时候退出循环
                    this.selectSpec = {
                        '授权场景:': x.scene_id,
                        '授权权益:': x.auth_info_id,
                        '类型:': x.auth_type,
                        '投放渠道:': x.channel_id,
                        '授权时间:': x.auth_time_id,
                        '授权范围:': x.auth_scope_id,
                    }
                    return true
                }
            } else {
                // console.log(i[auth_info_id])
                if (i[j] == its.name && i.scene_id == this.scene_id && i['auth_info_id'] == this.selectSpec['授权权益:'] && j != 'id') {
                    // 点场景的时候退出循环
                    this.selectSpec = {
                        '授权场景:': x.scene_id,
                        '授权权益:': x.auth_info_id,
                        '类型:': x.auth_type,
                        '投放渠道:': x.channel_id,
                        '授权时间:': x.auth_time_id,
                        '授权范围:': x.auth_scope_id,
                    }
                    return true
                }
            }
        }
      })

      // let ii = 0, temp = []
      // this.arr = []
      // for (let key in this.selectSpec) {
      //   let ids = []
      //   temp.push(this.selectSpec[key])
      //   ids.push(...this.isAble(ii, this.selectSpec[key], ii >= 1 ? temp[ii-1] : 0, this.scene_id))
      //   this.arr[key] = ids
      //   this.arr.push(...new Set(ids))
      //   ii++
      // }

        // console.log(this.selectSpec)

        let skuArr = this.intersect(this.skuMatrix[this.selectSpec['授权场景:']],this.skuMatrix[this.selectSpec['授权权益:']])
        let auth_info_ids = this.getSceneInfoIds(this.scene_id)
        skuArr.push(...auth_info_ids)
        skuArr = [...new Set(skuArr)]

        this.specList.forEach(item => {
            item.list.forEach((its, idx) => {
                its.able = skuArr.indexOf(its.name) >= 0;
            })
        });
    },
    handlePayClose() {
      this.addShopCar = false
    },
    handleTransfer() {
      this.$refs.transfer.payDialogVisible = true
    },
    addCar(event) {
      for (let i in this.selectSpec) {
        if (this.selectSpec[i] == '') {
          let newArr = i.split(':')
          this.$msg('error', '提示', `请选择${newArr[0]}`)
          return false
        }
      }
      let data = {
        goods_id: this.goodsInfo.id,
        price_id: this.price_id,
        type: this.goodsInfo.type,
      }
      // console.log(data)
      if (data.price_id == '') {
        return this.$msg('error', '提示', '请选择价格')
      }
      this.$home.addCart(data).then(res => {
        if (res.code == 200) {
          let x = event.clientX - event.target.offsetWidth / 2;
          let y = event.clientY - event.target.offsetWidth / 2;
          this.createBall(x, y);
          this.addCarSuccess = true
          this.$store.commit('setCartNum', res.data.num)
          this.$emit('newItemCartStatus', true)
          if (this.goodsInfo.id == this.$store.state.PutOnMusic.id) {
            let store = this.$store.state.PutOnMusic
            store.isCart = 1
            this.$store.commit('setPutOnMusic', store)
          }
        } else {
          this.$msg('error', '提示', res.msg)
        }
      }).catch(err => {
      })
    },
    // 修改购物车授权信息
    changeInfo() {
      for (let i in this.selectSpec) {
        if (this.selectSpec[i] == '') {
          let newArr = i.split(':')
          this.$msg('error', '提示', `请选择${newArr[0]}`)
          return false
        }
      }
      let data = {
        id: this.goodsInfo.id,
        price_id: this.price_id,
      }
      this.$home.editAuthInfo(data).then(res => {
        if (res.code == 200) {
          this.$emit('changeinfo')
          this.addShopCar = false
        } else {
          this.$msg('error', '提示', res.msg)
        }
      }).catch(err => {
      })
    },
    handleClose() {
      this.addCarSuccess = false
      this.addShopCar = false
    },
    // 继续挑选音乐
    chooseMusic() {
      this.addCarSuccess = false
      this.addShopCar = false
    },
    goShopCar() {
      this.addCarSuccess = false
      this.addShopCar = false
      this.$router.push({
        path: '/shoppingCart',
        query: {
          scene_id: this.scene_id,
          goods_id: this.goodsInfo.id,
          price_id: this.price_id,
        }
      })
    },
    /* 创建小球，添加动画 */
    createBall(left, top) {
      let bar = document.createElement("div");
      bar.style.position = "fixed";
      bar.style.left = left + "px";
      bar.style.top = top + "px";
      bar.style.width = "50px";
      bar.style.zIndex = 9999;
      bar.style.height = "50px";
      bar.style.backgroundImage = `url(${this.goodsInfo.img})`
      bar.style.backgroundSize = 'cover'
      bar.style.borderRadius = "50%";
      bar.style.transition =
          "left .6s linear, top .6s cubic-bezier(0.5, -0.5, 1, 1)";
      document.body.appendChild(bar);
      // 添加动画属性
      setTimeout(() => {
        let target = ''
        if (this.goodsInfo.collect_music == 'collect_music') {
          target = this.$parent.$parent.$parent.$refs.header.$refs.shop;
        }
        else if (this.goodsInfo.addCarMove == 1) {
          target = this.$parent.$parent.$refs.header.$refs.shop;
        }
        else if (this.goodsInfo.type == 1) {
          target = this.$parent.$parent.$parent.$refs.header.$refs.shop;
        } else if (this.goodsInfo.type == 2) {
          target = this.$parent.$parent.$refs.header.$refs.shop;
        }
        bar.style.left = target.offsetLeft + target.offsetWidth / 6 + "px";
        bar.style.top = target.offsetTop + "px";
      }, 0);

      /**
       * 动画结束后，删除自己
       */
      bar.ontransitionend = function () {
        this.remove();
      };
    },
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  margin-left: 60px;
}

::v-deep .el-divider {
  height: .5px;
  background-color: #f2f2f2;
}

.choose_box {
  padding-bottom: 20px;
}

.choose {
  display: flex;
  margin-top: 14px;

  .spec {
    width: 560px;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }
}

.title1 {
  line-height: 31px;
  min-width: 80px;
}

.spec-item {
  display: inline-block;
  margin: 0;
  border: 1px solid #eee;
  cursor: pointer;
  border-radius: 2px;
}

.spec-item span {
  padding: 5px 10px;
  border: none;
  display: inline-block;
}

.active {
  border: 1px solid #d92a20;
  background-color: white;
  color: #D92A20;
}

.disabled {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  //border-color: #ebeef5;
  border: 1px solid #c8c9cc;
  display: none;
}

::v-deep .el-dialog__title {
  font-weight: 600;
}

::v-deep .el-alert__content {
  padding: 0;
}

::v-deep .el-alert--warning.is-light {
  padding: 10px;
  font-size: 12px;
}

::v-deep .el-alert__title {
  font-size: 10px;
}

::v-deep .el-dialog {
  max-height: 580px;
  overflow-y: auto;
}

::v-deep .el-dialog__header {
  padding: 20px 30px;
  padding-bottom: 10px;
}



.pay_dialog {

  ::v-deep .el-dialog__body {
    margin: 0 30px;
    padding: 0;
    margin-bottom: 20px;
    padding-bottom: 10px;

    .el-divider--horizontal {
      margin: 14px 0 24px 0;
    }
  }


  ::v-deep .el-dialog {
    .buy_info {
       display: flex;
       justify-content: space-between;

      .buy_left {
        flex: 1;
        .buy_left_title {
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          img {
            width: 41px;
            height: 41px;
            opacity: 1;
            margin-right: 7px;
          }

          >div {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 16px;
          }

        }

        .scenario {
          margin-top: 4px;
          border-bottom: 1px dashed #AAAAAA;
          padding-bottom: 20px;

          >div {
            display: flex;
            margin-top: 14px;
          }

          p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            flex-shrink: 0;
          }

          .item_box {
            display: flex;
            flex-wrap: wrap;

            .item {
              padding: 0 6px;
              background: #FFFFFF;
              border-radius: 3px 3px 3px 3px;
              opacity: 1;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 28px;
              margin-left: 8px;
              margin-bottom: 6px;
              border: 1px solid #E7E7E7;
              cursor: pointer;
            }

            .active {
              border: 1px solid #D92A20;
            }
          }
        }

        .car_footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 25px;

          p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #3f1212;
            line-height: 16px;

            span {
              font-size: 20px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #D92A20;
              line-height: 14px;
            }
          }

          .custom {
            color: #d92a20;
            cursor: pointer;
            font-size: 15px;
          }
        }

        .inquiry {
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #D92A20;
          color: #D92A20;
        }

        .newinquiry {
          //color: white;
        }
      }
      .buy_right {
        width: 250px;
        margin-left: 30px;
        margin-top: 20px;

        .noApprove {
          width: 66px;
          height: 66px;
          margin: 20px auto;
        }

        .buyNow {
          font-size: 15px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          text-align: center;
          margin: auto;
          margin-top: 12px;
        }


        >span {
          display: block;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin: 12px 0 20px 0;
          text-align: justify;
        }

        .payMoney {
          font-size: 14px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 16px;

          span {
            font-size: 14px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #D92A20;
            line-height: 16px;
          }

          .big {
            font-size: 22px;
          }
        }

        .custom {
          color: #d92a20;
          cursor: pointer;
          font-size: 15px;
        }

        .qrcode {
          position: relative;
          max-width: 130px;
          max-height: 130px;
          margin: 20px 0 10px 0;

          .qrcode_border {
            width: 130px;
            height: 130px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #D9D9D9;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .isEwm {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            color: white;
            background-color: rgba(0, 0, 0, .7);

          }
        }

        .pay_way {
          img {
            width: 30px;
            height: 30px;
            margin-right: 4px;
          }

          p {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
            margin-bottom: 8px;
          }
        }

        a {
          color: #D92A20;
          display: inline-block;
          margin-top: 15px;
          font-size: 12px;
        }

      }
      .newBuy_Right {
        width: 200px;
        background: #F8F8F8;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        padding: 20px 24px;
        text-align: center;
        margin: 0;
        margin-left: 10px;
        .receive {
          margin: 10px 0;
        }

        .tips {
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin: 0 0 20px 0;
        }
      }

    }
  }

}

.addCarSuccess {
  .payCarSuccess_title {
    display: flex;
    align-items: center;

    img {
      width: 25px;
      height: 25px;
    }

    p {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 23px;
      margin-left: 9px;
    }
  }

  .payCarSuccess_info {
    display: flex;
    margin-top: 24px;
    align-items: center;

    img {
      width: 92px;
      height: 93px;
      opacity: 1;
    }

    >div {
      margin-left: 13px;

      p {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      .hidden {
        width: 300px;
        margin: 13px 0 18px 0;
      }

      span {
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #D92A20;
        line-height: 14px;
      }
    }
  }

  ::v-deep .el-dialog__body {
    margin: 0 30px;
    padding: 0;
    margin-bottom: 20px;
    padding-bottom: 10px;

    .el-divider--horizontal {
      margin: 14px 0 24px 0;
    }
  }

}
</style>
